export const selectTicketsData = (state) =>
  state.communicationEntityReducer.ticketData

export const selectAnnouncementsData = (state) =>
  state.communicationEntityReducer.announcementData
